import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import Swal from 'sweetalert2';
import { CampaignService } from 'src/app/services/campaigns/campaign.service';
import { CampaignEmployeeService } from 'src/app/services/campaign-employee/campaign-employee.service';

@Component({
	selector: 'app-campaign-employee',
	templateUrl: './campaign-employee.component.html',
	styleUrls: ['./campaign-employee.component.scss'],
})
export class CampaignEmployeeComponent implements OnInit {
	@Input() campaignID: number;
	SearchFilters = [];
	employeeUsersActive = [];
	//table
	employeeUsers = [];
	columnMode = ColumnMode;
	SelectionType = SelectionType;
	selected = [];
	disableCheckbox = false;
	assignAll = false;

	constructor(private campaignEmployeeService: CampaignEmployeeService,
				private campaignSrv: CampaignService) {}

	//field search
	@ViewChild('Login') login: ElementRef;
	@ViewChild('First') first: ElementRef;
	@ViewChild('last') last: ElementRef;

	ngOnInit(): void {
		this.getListUsers();
	}

	getListUsers() {
		if (this.campaignID != null || this.campaignID != 0) {
			this.campaignSrv.getCampaignCallers(this.campaignID).subscribe((data: any)=>{
				this.employeeUsers = data.body;
				this.assignAll = this.areAllAssigned();
				this.disableCheckbox = false;
			});
		}
	}

	assignUsersActive() {
		for (let users of this.employeeUsers) {

			if (users.isActive == '1') {
				this.employeeUsersActive.push(users);
			}
		}

		this.selected = this.employeeUsersActive;
	}

	assignCampaignConfirm(data) {
		Swal.fire({
			title: 'Assign ' + data.First + ' ' + data.Last + '?',
			text: 'ARE YOU SURE?',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result.value) {
				this.campaignEmployeeService
					.assignCampaignToUser(data.userid, this.campaignID)
					.subscribe((data: any) => {
						if (data.body == 'Done') {
							Swal.fire("Correctly Assigned");
						} else if (data.error) {
							Swal.fire("Error, Assigning employee");
						}
					});
			} else {
				this.getListUsers();
			}
		});
	}

	// removeCampaignConfirm(data) {
	// 	Swal.fire({
	// 		title: 'Remove ' + data.First + ' ' + data.Last + '?',
	// 		text: 'ARE YOU SURE?',
	// 		showCancelButton: true,
	// 		confirmButtonText: 'Yes',
	// 		cancelButtonText: 'Cancel',
	// 	}).then((result) => {
	// 		if (result.value) {
	// 			this.campaignEmployeeService
	// 				.removeUser(data.userid, this.campaignID)
	// 				.then((data) => {
	// 					if (data.success) {
	// 						Swal.fire(data.message);
	// 					} else if (data.error) {
	// 						Swal.fire(data.message);
	// 					}
	// 				});
	// 		} else {
	// 			this.employeeUsers = [];
	// 			this.selected = [];
	// 			this.employeeUsersActive = [];
	// 			this.getListUsers();
	// 		}
	// 	});
	// }

	unAssignUser(user){
		this.disableCheckbox = true;
		this.campaignEmployeeService
					.removeUser(user, this.campaignID)
					.subscribe((data: any) => {
						if (data.body == 'Done') {

							this.getListUsers();
						} else if (data.error) {
							Swal.fire("Error, Unassigning employee");
							this.disableCheckbox = false;
						}
					});
	}

	assignUser(user){
		this.disableCheckbox = true;
		this.campaignEmployeeService
		.assignCampaignToUser(user, this.campaignID)
		.subscribe((data: any) => {
			if (data.body == 'Done') {
				this.getListUsers();
			} else if (data.error) {
				Swal.fire("Error, Assigning employee");
				this.disableCheckbox = false;
			}
		});
	}

	cleanFiltersSearch() {
		this.login.nativeElement.value = '';
		this.first.nativeElement.value = '';
		this.last.nativeElement.value = '';

		this.getListUsers();
	}

	updateFilter(event, opcion) {
		const val = event.target.value.toLowerCase();
		let answer_filter: any[];
		let searchWithFilters: any[];

		if (val != '') {
			searchWithFilters = this.employeeUsers;
		} else {
			searchWithFilters = this.SearchFilters;
		}

		switch (opcion) {
			case 1: //login
				answer_filter = searchWithFilters.filter(function (d) {
					return d.Login.toLowerCase().indexOf(val) !== -1 || !val;
				});

				break;
			case 2: //first
				answer_filter = searchWithFilters.filter(function (d) {
					return d.First.toLowerCase().indexOf(val) !== -1 || !val;
				});

				break;
			case 3: //last
				answer_filter = searchWithFilters.filter(function (d) {
					return d.Last.toLowerCase().indexOf(val) !== -1 || !val;
				});

				break;
			default:
				break;
		}

		this.employeeUsers = answer_filter;
	}

	// onActivate(event) {
	// 	if (event.type === 'click') {
	// 		if (event.row.IsActive === '1') {
	// 			this.removeCampaignConfirm(event.row);
	// 		} else {
	// 			this.assignCampaignConfirm(event.row);
	// 		}
	// 	}
	// }


	checkBoxClick(row, event){
		event.preventDefault();
		if(event.target.checked){
			this.assignUser(row.id);
		} else {
			this.unAssignUser(row.id);
		}
	}

	assignAllCallers(){
		this.assignAll = !this.assignAll;
		this.disableCheckbox = true;



		if(!this.assignAll){
			const payload = {
				users: this.employeeUsers.filter(user => user.assigned == '1').map(user => user.id).join(','),
				campaign_id: this.campaignID
			}
			this.campaignSrv.removeAllUsersFromCampaign(payload).subscribe((data: any)=>{
				this.getListUsers();
			});
		} else {
			const payload = {
				users: this.employeeUsers.filter(user => user.assigned == '0').map(user => user.id).join(','),
				campaign_id: this.campaignID
			}
			this.campaignSrv.assignAllUsersToCampaign(payload).subscribe((data: any)=>{
				this.getListUsers();
			});
		}
	}

	areAllAssigned(){
		return this.employeeUsers.every(user => user.assigned == '1');
	}
}
